import React, { useEffect, useRef, useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { locationBounds } from '../../components/LocationAutocompleteInput/GeocoderMapbox';
import {
  Form,
  Button,
  InlineTextButton,
  FieldAddress,
  FieldCheckbox,
  Modal,
} from '../../components';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './EditListingLocationForm.module.css';
import config from '../../config';
import CustomSearchMap from '../../components/Map/CustomSearchMap';
import axios from 'axios';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router-dom';

const identity = v => v;
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const LOCATION_BOUNDS = 1000;
const { LatLng } = sdkTypes;
const irelandCords = { lat: 53.1423672, lng: -7.692053599999999 };

export const EditListingLocationFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        userNativeLang,
        values,
        isRequired,
        form,
        ProviderAddress,
        location,
        listing,
        errors,
        history,
        onManageDisableScrolling,
      } = formRenderProps;
      const [defaultAddress, setDefaultAddress] = useState(values.isSameAddressAsProfile);

      const [bounds, setBounds] = useState(null);
      const [origin, setOrigin] = useState(null);
      const [myadd, setMyAdd] = useState('');
      const [postAddress, setPostAddress] = useState('');
      const [lat, setLat] = useState(null);
      const [lng, setLng] = useState(null);
      const newListing = useRef({ ...listing });
      const formRef = useRef(null);
      const [initialMapUpdate, setInitialMapUpdate] = useState(false);
      const [noProviderAddressError, setNoProviderAddressError] = useState(false);
      useEffect(() => {
        const geolocation = listing.attributes.geolocation;
        let org;
        if (geolocation) {
          org = geolocation;
          getAddress(listing?.attributes?.publicData?.listingAddress?.address);
        } else {
          org = new LatLng(irelandCords.lat, irelandCords.lng);
        }
        setOrigin(org);
        const dist = geolocation ? 1000 : 10000;
        setBounds(locationBounds(org, dist));
      }, []);

      const getAddress = async location => {
        if (true) {
          try {
            const mapboxData = await axios.get(
              `https://api.mapbox.com/geocoding/v5/mapbox.places/${location}.json?proximity=ip&types=place%2Cpostcode%2Caddress&access_token=${config.maps.mapboxAccessToken}`
            );
            const currentPoint = mapboxData.data.features[0];
            const currentLat = currentPoint.geometry.coordinates[1];
            const currentLng = currentPoint.geometry.coordinates[0];
            const currentCounty =
              currentPoint.context?.find(c => c.id?.includes('place')) &&
              currentPoint.context?.find(c => c.id?.includes('place')).text;
            const currentRegion =
              currentPoint.context?.find(c => c.id?.includes('region')) &&
              currentPoint.context?.find(c => c.id?.includes('region')).text;
            const country =
              currentPoint.context?.find(c => c.id?.includes('country')) &&
              currentPoint.context?.find(c => c.id?.includes('country')).text;
            const currentAddress = currentPoint.place_name;
            const county = currentCounty;
            const area = currentRegion;
            const org = new LatLng(currentLat, currentLng);

            setLat(currentLat);
            setLng(currentLng);
            setOrigin(org);
            setBounds(locationBounds(org, LOCATION_BOUNDS));
            newListing.current.attributes.geolocation = new LatLng(org.lat, org.lng);
            setInitialMapUpdate(true);
            form.change('county', county);
            form.change('city', county ? area : null);
            form.change('country', country);
            form.change('lat', currentLat);
            form.change('lng', currentLng);
            form.change('currentAddress', currentAddress);
            setTimeout(() => setInitialMapUpdate(false), 300);
          } catch (error) { }
        } else {
        }
      };

      const { isSameAddressAsProfile } = values;

      const handleSameAddress = value => {
        if (!values.ProviderAddress) {
          setNoProviderAddressError(true);
        } else {
          setDefaultAddress(!defaultAddress);
          setMyAdd(values.ProviderAddress.address);
          setPostAddress(values.ProviderAddress.postalCode);

          if (value[0] === 'true') {
            form.change('listingAddress', values.ProviderAddress);
          }
          form.change('isSameAddressAsProfile', value);

          getAddress(values.ProviderAddress.address);
        }
      };

      // business address
      const addressLabel = intl.formatMessage({
        id: 'SignupForm.adrressLabel',
      });
      const addressPlaceholder = intl.formatMessage({
        id: 'SignupForm.adrressPlaceholder',
      });
      const postalLabel = intl.formatMessage({
        id: 'SignupForm.postalLabel',
      });
      const postalPlaceholder = intl.formatMessage({
        id: 'SignupForm.postalPlaceholder',
      });
      const postalAddressRequiredMessage = intl.formatMessage({
        id: 'SignupForm.adrressRequired',
      });
      const postalAddressRequired = validators.addressRequired(postalAddressRequiredMessage);

      const titleRequiredMessage = intl.formatMessage({
        id: 'EditListingLocationForm.address',
      });
      const addressPlaceholderMessage = intl.formatMessage({
        id: 'EditListingLocationForm.addressPlaceholder',
      });
      const addressRequiredMessage = intl.formatMessage({
        id: 'EditListingLocationForm.addressRequired',
      });
      const addressNotRecognizedMessage = intl.formatMessage({
        id: 'EditListingLocationForm.addressNotRecognized',
      });

      const optionalText = intl.formatMessage({
        id: 'EditListingLocationForm.optionalText',
      });

      const buildingMessage = intl.formatMessage(
        { id: 'EditListingLocationForm.building' },
        { optionalText: optionalText }
      );
      const buildingPlaceholderMessage = intl.formatMessage({
        id: 'EditListingLocationForm.buildingPlaceholder',
      });

      const sameAddressAbove = intl.formatMessage({
        id: 'EditListingLocationForm.sameAddressAboveLabel',
      });

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingLocationForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingLocationForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;

      const submitDisabled =
        disabled ||
        pristine ||
        submitInProgress ||
        !values.listingAddress?.address ||
        !values.listingAddress?.postalCode;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <FieldAddress
            id="listingAddress"
            name="listingAddress"
            addressLabel={addressLabel}
            addressPlaceholder={addressPlaceholder}
            postalLabel={postalLabel}
            postalPlaceholder={postalPlaceholder}
            // className={textfield}
            className={classNames(css.locationAddress, textfield, {
              [css.disabledField]: !!defaultAddress,
            })}
            errorClassName={errorTextField}
            validate={postalAddressRequired}
            onChange={e => {
              const value = e.address;
              form.change('isSameAddressAsProfile', null);
              const postalAddress = e.postalCode;
              setPostAddress(postalAddress);
              setMyAdd(value);
              if (value?.length > 4) {
                getAddress(value);
              }
              form.change('listingAddress', e);
            }}
            userNativeLang={userNativeLang}
            disabled={!!defaultAddress}
          />

          <div className={classNames(css.fieldDiv, css.locatnFieldDiv)}>
            <FieldCheckbox
              id="EditlistingAddress"
              name="isSameAddressAsProfile"
              label={sameAddressAbove}
              value={'true'}
              onChange={handleSameAddress}
            />
            <Modal
              id="EditListingLocationForm.noDefaultAddressModal"
              isOpen={!!noProviderAddressError}
              onClose={() => {
                setNoProviderAddressError(false);
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              usePortal
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}></div>
                <div className={css.modalDesc}>
                  <span className={css.noDefaultAddress}>
                    <FormattedMessage id="EditListingLocationForm.noDefaultAddress" />
                  </span>
                </div>
                <Button
                  type="button"
                  className={css.modalSubmitButton}
                  onClick={() => {
                    history.push(
                      createResourceLocatorString(
                        'ProfileSettingsPage',
                        routeConfiguration(),
                        { id: listing?.author?.id?.uuid },
                        {}
                      )
                    );
                  }}
                >
                  <FormattedMessage id="ListingPage.gotoProfileSettings" />
                </Button>
              </div>
            </Modal>
          </div>

          <CustomSearchMap
            className={css.mapDiv}
            key="EditlistingPage.map"
            reusableContainerClassName={css.maps}
            activeListingId={null}
            bounds={bounds}
            center={origin}
            isSearchMapOpenOnMobile={true}
            location={location}
            listings={[newListing.current]}
            onMapMoveEnd={() => { }}
            onCloseAsModal={() => {
              onManageDisableScrolling('EditlistingPage.map', false);
            }}
            messages={intl.messages}
            // setPickupAddress={getAddressFromLatLng}
            initialMapUpdate={initialMapUpdate}
            showCustomMap={true}
            boundsDistance={LOCATION_BOUNDS}
          />
          <div className={css.ButtonContainer}>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                // form.reset;
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingLocationFormComponent.defaultProps = {
  selectedPlace: null,
  fetchErrors: null,
};

EditListingLocationFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  selectedPlace: propTypes.place,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(
  withRouter,
  injectIntl
)(EditListingLocationFormComponent);